function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.039 13.547L9.586 10 8.322 8.737a5 5 0 1 1 1.209-1.62L11 8.586l1.469-1.47a5 5 0 1 1 1.209 1.62L12.414 10l3.547 3.547a3 3 0 0 1 .827 2.674l-2.437 12.997a3.41 3.41 0 0 1-6.114 1.372 7.272 7.272 0 0 1-4.718-8.286l1.327-6.633a3 3 0 0 1 .607-1.295 2.97 2.97 0 0 1 .586-.829zm1.358 14.332l-1.429-7.622-.487 2.44a5.27 5.27 0 0 0 1.916 5.182zm.056-12.918a1 1 0 0 0-.276.892L9.614 28.85a1.41 1.41 0 0 0 2.772 0l2.437-12.997a1 1 0 0 0-.276-.892L13.586 14H8.414l-.96.961zM5 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm12 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-7 8h2v2h-2v-2zm14 14v-2h-4v-2h4v-2h-4v-2h4v-2h-4v-2h4v-2h-4v-2h4v-2h-4v-2h7a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5h-7v-2h4zm2-18v18h1a3 3 0 0 0 3-3V15a3 3 0 0 0-3-3h-1z"
});

var SvgGrooming = function SvgGrooming(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "ae959d54156dba8b543b31aa09ca2c1b.svg";
export { SvgGrooming as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/grooming.svg
// module id = null
// module chunks = 